import React, { useState } from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import * as styles from './homeMatchHero.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function HomeMatchHero(props) {

    const featuredimg = maybeImage(props.featuredImage);
    const sectionimg = maybeImage(props.sectionImage);

    let heroContentClass = styles.heroContentWrap + ' ' + ((props.hasSearchBar) ? styles.hasSearchBar : 'no-search-bar');

    return (
        <div className={styles.sectionHomeMatchHero}>

            <div className={styles.heroWrap}>
                <div className={styles.heroContainer}>
                    <div className={styles.bgCircle}>
                        <img src={require('../images/hero_circle.png').default} alt="Download in Google Play" />
                    </div>
                    <div className={styles.featuredImageWrap}>
                        {featuredimg}
                    </div>
                    <div className={heroContentClass}>
                        <h1>
                            <PortableText blocks={props.heading} />
                        </h1>
                        <div className={styles.mobileImage}>
                            {featuredimg}
                        </div>
                        <div className={styles.contentWrap}>
                            <PortableText blocks={props.content} />
                        </div>
                        {
                            (props.hasSearchBar) ? 
                                <div className={styles.tagSearchBar}>
                                    <i class="fas fa-search"></i>
                                    <input type="text" name="address_search" placeholder="Address" required />
                                    <a href="#" className={styles.addressSearchBtn}>
                                        <span class="inline-block align-middle">Search</span>
                                        <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                                    </a>
                                </div>
                                : ``
                        }
                        <div className={styles.ctaWrap}>
                            {
                                (props.appStoreLink) ? 
                                <a href={props.appStoreLink} target="_blank">
                                    <img src={require('../images/app_store_2.png').default} alt="Download in App Store" />
                                </a> 
                                : ``
                            }
                            {
                                (props.playStoreLink) ? 
                                <a href={props.playStoreLink} target="_blank">
                                    <img src={require('../images/google_play_2.png').default} alt="Download in Google Play" />
                                </a> 
                                : ``
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.preSectionWrap}>
                <div className={styles.sectionContainer}>
                    <div className={styles.sectionFirstCol}>
                        <div className={styles.imageWrapper}>{sectionimg}</div>
                    </div>
                    <div className={styles.sectionSecondCol}>
                        <div className={styles.sectionContent}>
                            <h3>{props.sectionTitle}</h3>
                            <PortableText blocks={props.sectionContent} />
                            <a href={props.sectionCtaLink} className={styles.sectionCta}>
                                <span class="inline-block align-middle">{props.sectionCtaLabel}</span>
                                <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default HomeMatchHero;
